var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHiddenEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6598 9.17892C21.2618 9.7176 21.7688 10.2404 22.1491 10.6524C22.4118 10.9435 22.5572 11.3217 22.5572 11.7139C22.5572 12.106 22.4118 12.4843 22.1491 12.7754C20.4855 14.5657 16.6989 18.0512 12.2786 18.0512H11.6449M7.31964 16.6729C5.4844 15.645 3.82613 14.3291 2.40819 12.7754C2.14544 12.4843 2 12.106 2 11.7139C2 11.3217 2.14544 10.9435 2.40819 10.6524C4.07174 8.86206 7.85832 5.37651 12.2786 5.37651C14.021 5.41293 15.7263 5.88692 17.2376 6.75488M20.9925 3L3.56476 20.4277",
    stroke: "#6B6C80",
    strokeWidth: 1.8484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0446 13.9475C9.44957 13.356 9.1134 12.5526 9.10986 11.7136C9.10986 10.8732 9.44371 10.0672 10.0379 9.47301C10.6322 8.87876 11.4382 8.54492 12.2785 8.54492C13.1176 8.54846 13.9209 8.88462 14.5125 9.47968M15.0353 13.2979C14.7533 13.7801 14.3488 14.1791 13.8629 14.4545",
    stroke: "#6B6C80",
    strokeWidth: 1.32028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEye);
export default __webpack_public_path__ + "static/media/hiddenEye.89f158ae6b223a41e5692e28567afac4.svg";
export { ForwardRef as ReactComponent };